import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Profissional } from '../models/profissional.model';
import { Page } from '../models/page.model';

@Injectable({
  providedIn: 'root'
})
export class ProfissionalService extends BaseService<Profissional> {
  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/profissional`, injector);
  }

  calcularCustoHora(profissional: Profissional): Observable<Profissional> {
    return this.http.post<Profissional>(`${environment.API_PRICE}/profissional/calcularCustoHora`, profissional);
  }

  getByCargoId(cargoId: number): Observable<Page<Profissional>> {
    return this.http.get<Page<Profissional>>(`${environment.API_PRICE}/profissional/getByCargoId/${cargoId}`);
  }

  carregarProfissionais(file: FormData): Observable<boolean> {
    return this.http.post<boolean>(`${environment.API_PRICE}/profissional/carregar-profissionais`, file);
  }

  exportarProfissionais(): Observable<any> {
    return this.http.get(`${environment.API_PRICE}/profissional/exportar-profissionais`);
  }
}
